/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Delete_Translation_Confirm_TextInputs */

const en_delete_translation_confirm_text = /** @type {(inputs: Delete_Translation_Confirm_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Do you want to delete this translation file? This action cannot be undone.`)
};

const fr_delete_translation_confirm_text = /** @type {(inputs: Delete_Translation_Confirm_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voulez-vous supprimer ce fichier de traduction ? Cette action est irréversible.`)
};

const de_delete_translation_confirm_text = /** @type {(inputs: Delete_Translation_Confirm_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Möchten Sie diese Übersetzungsdatei löschen? Diese Aktion kann nicht rückgängig gemacht werden.`)
};

const it_delete_translation_confirm_text = /** @type {(inputs: Delete_Translation_Confirm_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vuoi eliminare questo file di traduzione? Questa azione non può essere annullata.`)
};

const ru_delete_translation_confirm_text = /** @type {(inputs: Delete_Translation_Confirm_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вы хотите удалить этот файл перевода? Это действие необратимо.`)
};

const es_delete_translation_confirm_text = /** @type {(inputs: Delete_Translation_Confirm_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Quieres eliminar este archivo de traducción? Esta acción no se puede deshacer.`)
};

const zh_cn2_delete_translation_confirm_text = /** @type {(inputs: Delete_Translation_Confirm_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`是否删除此翻译文件？此操作无法撤销。`)
};

const ja_delete_translation_confirm_text = /** @type {(inputs: Delete_Translation_Confirm_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`この翻訳ファイルを削除しますか? この操作は元に戻せません。`)
};

const hi_delete_translation_confirm_text = /** @type {(inputs: Delete_Translation_Confirm_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`क्या आप इस अनुवाद फ़ाइल को हटाना चाहते हैं? यह कार्रवाई पूर्ववत नहीं की जा सकती।`)
};

const pt_pt2_delete_translation_confirm_text = /** @type {(inputs: Delete_Translation_Confirm_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deseja excluir este arquivo de tradução? Esta ação não pode ser desfeita.`)
};

/**
* | output |
* | --- |
* | "Do you want to delete this translation file? This action cannot be undone." |
*
* @param {Delete_Translation_Confirm_TextInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const delete_translation_confirm_text = /** @type {((inputs?: Delete_Translation_Confirm_TextInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Delete_Translation_Confirm_TextInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_delete_translation_confirm_text(inputs)
	if (locale === "de") return de_delete_translation_confirm_text(inputs)
	if (locale === "it") return it_delete_translation_confirm_text(inputs)
	if (locale === "ru") return ru_delete_translation_confirm_text(inputs)
	if (locale === "es") return es_delete_translation_confirm_text(inputs)
	if (locale === "zh-CN") return zh_cn2_delete_translation_confirm_text(inputs)
	if (locale === "ja") return ja_delete_translation_confirm_text(inputs)
	if (locale === "hi") return hi_delete_translation_confirm_text(inputs)
	if (locale === "pt-PT") return pt_pt2_delete_translation_confirm_text(inputs)
	return en_delete_translation_confirm_text(inputs)
});